import React from 'react';
import styles from './SpacingEditor.module.css';

interface SpacingEditorProps {
  baseUnit: number;
  borderRadius: number;
  headerHeight: number;
  maxContentWidth: number;
  onChange: (field: keyof SpacingEditorProps, value: number) => void;
  defaults: {
    baseUnit: number;
    borderRadius: number;
    headerHeight: number;
    maxContentWidth: number;
  };
}

export const SpacingEditor: React.FC<SpacingEditorProps> = ({
  baseUnit,
  borderRadius,
  headerHeight,
  maxContentWidth,
  onChange,
  defaults,
}) => {
  return (
    <div className={styles.spacingEditor}>
      <div className={styles.formGroup}>
        <label>Base Unit (px)</label>
        <div className={styles.sliderContainer}>
          <input
            type="range"
            min="4"
            max="16"
            step="1"
            value={baseUnit}
            onChange={(e) => onChange('baseUnit', parseInt(e.target.value))}
            className={styles.slider}
          />
          <input
            type="number"
            min="4"
            max="16"
            step="1"
            value={baseUnit}
            onChange={(e) => onChange('baseUnit', parseInt(e.target.value) || defaults.baseUnit)}
            className={styles.numberInput}
          />
        </div>
        <span className={styles.helpText}>Base spacing unit for margins and paddings</span>
      </div>

      <div className={styles.formGroup}>
        <label>Border Radius (px)</label>
        <div className={styles.sliderContainer}>
          <input
            type="range"
            min="0"
            max="24"
            step="2"
            value={borderRadius}
            onChange={(e) => onChange('borderRadius', parseInt(e.target.value))}
            className={styles.slider}
          />
          <input
            type="number"
            min="0"
            max="24"
            step="2"
            value={borderRadius}
            onChange={(e) => onChange('borderRadius', parseInt(e.target.value) || defaults.borderRadius)}
            className={styles.numberInput}
          />
        </div>
        <span className={styles.helpText}>Corner radius for buttons, cards, and inputs</span>
      </div>

      <div className={styles.formGroup}>
        <label>Header Height (px)</label>
        <div className={styles.sliderContainer}>
          <input
            type="range"
            min="44"
            max="80"
            step="2"
            value={headerHeight}
            onChange={(e) => onChange('headerHeight', parseInt(e.target.value))}
            className={styles.slider}
          />
          <input
            type="number"
            min="44"
            max="80"
            step="2"
            value={headerHeight}
            onChange={(e) => onChange('headerHeight', parseInt(e.target.value) || defaults.headerHeight)}
            className={styles.numberInput}
          />
        </div>
        <span className={styles.helpText}>Height of the global header</span>
      </div>

      <div className={styles.formGroup}>
        <label>Max Content Width (px)</label>
        <div className={styles.sliderContainer}>
          <input
            type="range"
            min="1024"
            max="1920"
            step="32"
            value={maxContentWidth}
            onChange={(e) => onChange('maxContentWidth', parseInt(e.target.value))}
            className={styles.slider}
          />
          <input
            type="number"
            min="1024"
            max="1920"
            step="32"
            value={maxContentWidth}
            onChange={(e) =>
              onChange('maxContentWidth', parseInt(e.target.value) || defaults.maxContentWidth)
            }
            className={styles.numberInput}
          />
        </div>
        <span className={styles.helpText}>Maximum width for main content area</span>
      </div>

      <div className={styles.preview}>
        <label>Preview</label>
        <div
          className={styles.previewBox}
          style={{
            padding: `${baseUnit * 2}px`,
            borderRadius: `${borderRadius}px`,
          }}
        >
          <div className={styles.previewHeader} style={{ height: `${headerHeight}px` }}>
            Header
          </div>
          <div className={styles.previewContent} style={{ maxWidth: `${maxContentWidth}px` }}>
            Content area with base unit spacing of {baseUnit}px
          </div>
        </div>
      </div>
    </div>
  );
};
